module.exports = require('country-flag-icons/react/3x2')